import React from 'react';

import { Gutter, Tabs } from '@common/components';
import { useNavigate, useParams, useQuery } from '@common/hooks';
import { MissionControlBasePage } from '@institutions/pages';
import { MISSION_CONTROL_STAFFING_REQUEST_COUNTERS_QUERY } from '@jobs/graphql';
import { MissionControlStaffingTableApprovalQueue } from './_mission-control-staffing-table-approval-queue';
import { MissionControlStaffingTableCandidatesInScreening } from './_mission-control-staffing-table-candidates-in-screening';
import { MissionControlStaffingTableOffersPending } from './_mission-control-staffing-table-offers-pending';
import { MissionControlStaffingTableRequestAtRisk } from './_mission-control-staffing-table-request-at-risk';
import { MissionControlStaffingTableReviewsPending } from './_mission-control-staffing-table-reviews-pending';

const { Tab, Pane } = Tabs;

export function MissionControlStaffingPage() {
  const { selectedTab } = useParams<{ selectedTab: string }>();
  const navigate = useNavigate();
  const { data } = useQuery(MISSION_CONTROL_STAFFING_REQUEST_COUNTERS_QUERY);

  const counts = data?.missionControlStaffingRequestCounters;
  const approvalQueue = counts?.approvalQueue || 0;
  const upcomingJobs = counts?.upcomingJobs || 0;
  const candidatesInScreening = counts?.candidatesInScreening || 0;
  const reviewsPending = counts?.reviewsPending || 0;
  const offersPending = counts?.offersPending || 0;

  const hasApprovalQueues = approvalQueue > 0;

  return (
    <MissionControlBasePage section="staffing">
      <Tabs
        defaultActiveKey={selectedTab}
        onTabClick={(key) =>
          navigate(`/works/home/staffing/${key}`, { replace: true })
        }
      >
        {hasApprovalQueues && (
          <Pane
            tab={<Tab title="Approval queue" count={approvalQueue} />}
            key="approvals"
          >
            <Gutter size="lg" direction="vertical">
              <MissionControlStaffingTableApprovalQueue />
            </Gutter>
          </Pane>
        )}
        <Pane
          tab={<Tab title="Upcoming Jobs" count={upcomingJobs} />}
          key="requests"
        >
          <Gutter size="lg" direction="vertical">
            <MissionControlStaffingTableRequestAtRisk />
          </Gutter>
        </Pane>
        <Pane
          tab={
            <Tab
              title="Candidates in screening"
              count={candidatesInScreening}
            />
          }
          key="candidates"
        >
          <Gutter size="lg" direction="vertical">
            <MissionControlStaffingTableCandidatesInScreening />
          </Gutter>
        </Pane>
        <Pane
          tab={<Tab title="Reviews pending" count={reviewsPending} />}
          key="reviews"
        >
          <Gutter size="lg" direction="vertical">
            <MissionControlStaffingTableReviewsPending />
          </Gutter>
        </Pane>
        <Pane
          tab={<Tab title="Offers pending" count={offersPending} />}
          key="offers"
        >
          <Gutter size="lg" direction="vertical">
            <MissionControlStaffingTableOffersPending />
          </Gutter>
        </Pane>
      </Tabs>
    </MissionControlBasePage>
  );
}
